import type { SupabaseClient } from '@supabase/supabase-js';

/**
 * Cliente do banco usado pelos serviços compartilhados (pontos, gamificação).
 * No navegador é o cliente da sessão do usuário; no servidor, o service role.
 * Assim a mesma lógica roda no servidor sem depender do navegador.
 */
let cliente: SupabaseClient | null = null;

export function configurarClienteBanco(c: SupabaseClient) {
  cliente = c;
}

// tipado como any, como o cliente original (os serviços usam .catch em consultas)
export const db: any = new Proxy({} as SupabaseClient, {
  get(_alvo, prop) {
    if (!cliente) throw new Error('Cliente do banco não configurado (configurarClienteBanco).');
    const valor = (cliente as any)[prop];
    return typeof valor === 'function' ? valor.bind(cliente) : valor;
  }
});
